import React from 'react';
import '../css/styles.css';
import AboutPage from '../media/AboutPage';

const Home = () => {
  return (
    // change padding for mobile below
    <div style={{marginLeft: '14%', marginRight: '14%'}}>

      <AboutPage/>

      <div>
        <h3 className='text'> </h3>
      </div>
      
    </div>
  );
};

export default Home;
